import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { DetailedChangeset } from 'ember-changeset/types';
import type AgreementModel from 'garaje/models/agreement';
import type FlowModel from 'garaje/models/flow';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';
import { buildChangeset, FakeChangeset } from 'garaje/utils/legal-document';
import { alias, collect } from 'macro-decorators';

interface FlowsSectionsLegalDocumentsEditComponentSignature {
  Args: {
    agreement: AgreementModel;
    flow: FlowModel;
    agreements: AgreementModel[];
  };
}

export default class FlowsSectionsLegalDocumentsEditComponent extends Component<FlowsSectionsLegalDocumentsEditComponentSignature> {
  @service declare state: StateService;
  @service declare metrics: MetricsService;
  @service declare router: RouterService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare flashMessages: FlashMessagesService;

  @alias('state.vrSubscription') vrSubscription!: StateService['vrSubscription'];
  @collect('bccChangeset', 'ndaChangeset') changesets!: DetailedChangeset<AgreementModel>[];

  get bccChangeset(): DetailedChangeset<AgreementModel> {
    return buildChangeset(this.args.agreement);
  }

  get ndaChangeset(): DetailedChangeset<AgreementModel> {
    return buildChangeset(this.args.agreement);
  }

  get isSaved(): boolean {
    return !this.args.agreement.isNew && !this.args.agreement.hasDirtyAttributes;
  }

  get shouldRenderDelete(): boolean {
    if (!this.args.flow.canEdit) {
      return false;
    }

    return this.args.agreements.length > 1;
  }

  get changeset(): FakeChangeset {
    const changesets = this.changesets ?? [];
    return new FakeChangeset(changesets);
  }
}
